export function init_mobileMenu() {
    
    const HAMBURGER = document.getElementById('mobile-menu-btn');
    const MOBILE_MENU = document.getElementById('mobile-menu-wrap');
    const MOBILE_MENU_LINKS = MOBILE_MENU.querySelectorAll('li');
    let isOpen = false;

    let menuAni = new TimelineLite({paused:true});

    menuAni.fromTo( MOBILE_MENU, 0.6, {
        y: "-100%",
    },{
        y: "0%",
        ease:Power3.easeInOut
    }).staggerFromTo( MOBILE_MENU_LINKS, 0.6, 
        { opacity: 0, y: "40px" }, 
        { opacity: 1, y: 0, ease:Power1.easeInOut }, 0.06, 0.2);

        
    if( HAMBURGER ){
        HAMBURGER.addEventListener('click', (e) => {
            isOpen = !isOpen;
            e.currentTarget.innerHTML = isOpen
                ? 'Close'
                : 'Menu';
            
            if( isOpen ){
                menuAni.play().timeScale(1);
            }
            else{
                menuAni.reverse().timeScale(1.3);
            }
        });
    }
    document.addEventListener('keydown', (e) => {
        e = e || window.event;
        if (e.keyCode == 27) {
            if ( isOpen ){ isOpen = false; }
            HAMBURGER.innerHTML = 'Menu'; 
            menuAni.reverse().timeScale(1.3);
        }
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/mobile-menu.js